import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 135,
  },
  textAlignCenter: {
    textAlign: 'center',
  },
  marginStyle: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  paperStyle: {
    width: 380,
    height: 70,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    padding: 15,
    borderBottom: '1px solid',
    borderBottomColor: '#e3e3e3',
  },
  sorter: {
    width: '100%',
    height: 28,
    borderBottom: '1px solid',
    borderBottomColor: '#e3e3e3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#969595',
  },
  button: {
    minWidth: 60,
    height: 40,
    fontSize: 20,
  },
  label: {
    textTransform: 'none',
  },
  textField: {},
  root: {
    width: 380,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  nestedCountries: {
    paddingLeft: theme.spacing(10),
  },
  parentPaper: {
    position: 'absolute',
    marginTop: 0,
    zIndex: 300,
    maxHeight: 400,
    overflow: 'auto',
  },
  availabilityTextFieldParent: {
    minWidth: 150,
  },
  searchButtonPopover: {
    padding: '7px',
    transform: 'translate(-8px, -16px)!important',
    width: '395px',
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  alignCenter: {
    alignItems: 'center',
  },
  buttonApply: {
    height: '45px',
  },
  checkbox: {
    marginLeft: '-4px',
  },
  checkboxRegion: {
    paddingLeft: 4,
  },
  checkboxCountry: {
    paddingRight: 0,
  },
  formControlRightFilters: {
    margin: theme.spacing(1),
  },
}));

export default styles;
